import { jsx as o } from "react/jsx-runtime";
import { getChevronIconStyles as n } from "../styles.js";
const t = (r) => /* @__PURE__ */ o(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: n(r),
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M11.9599 19.7423C11.2755 19.7423 10.6888 19.4489 10.2976 18.96L0.617397 8.10643C0.0306973 7.32413 0.128497 6.15073 0.910697 5.56413C1.6929 4.97743 2.7685 4.97743 3.3552 5.75963L11.7644 15.3421C11.8621 15.4399 11.9599 15.4399 12.1555 15.3421L20.5646 5.75963C21.2491 4.97743 22.3247 4.87963 23.1069 5.56413C23.8891 6.24863 23.9869 7.32413 23.3025 8.10643L23.2047 8.20413L13.6222 19.0578C13.2311 19.4489 12.5466 19.7423 11.9599 19.7423Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  t as SolidChevronDownIcon
};
//# sourceMappingURL=SolidChevronDownIcon.js.map
